/**
 * Configuração de ambiente, lida uma vez e validada na carga do módulo.
 *
 * Falhar aqui, no import, é deliberado: um bundle publicado sem `VITE_SUPABASE_URL`
 * produziria telas vazias com erro de rede em cada query — muito mais difícil de
 * diagnosticar do que uma falha imediata e explícita. (Padrão do Hub SISTEMAS.)
 */

function required(name: string, value: string | undefined): string {
  const trimmed = value?.trim()
  if (!trimmed) {
    throw new Error(
      `Variável de ambiente ausente: ${name}. ` +
        'Copie apps/web/.env.example para .env.local e preencha.',
    )
  }
  return trimmed
}

/**
 * Em produção o valor é `/supabase`, servido same-origin pelo nginx do app.
 * Nunca o IP interno do Kong: ele iria parar no bundle.
 */
const supabaseUrl = required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL)
const supabaseAnonKey = required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY)

/** `local` = GoTrue direto (Supabase CLI). `bridge` = spa-bridge same-origin (dev01/prod). */
const authModeRaw = import.meta.env.VITE_AUTH_MODE?.trim() ?? 'bridge'
const authMode = authModeRaw === 'local' ? 'local' : 'bridge'
const devPassword = import.meta.env.VITE_DEV_SUPABASE_PASSWORD?.trim()

// O modo local (login direto no GoTrue, sem SSO) existe só para `pnpm dev`. Num
// build de produção ele pularia o SSO inteiro — e o Vite carrega `.env.local`
// também no `vite build`. O `.dockerignore` tira o arquivo da imagem; esta é a
// segunda trava, a que não depende de lembrar de arquivo nenhum.
if (authMode === 'local' && !import.meta.env.DEV) {
  throw new Error(
    'VITE_AUTH_MODE=local num build de produção. O modo local é só para ' +
      '`pnpm dev`; em produção o login é sempre pelo SSO.',
  )
}

if (/service_role/.test(supabaseAnonKey)) {
  throw new Error(
    'VITE_SUPABASE_ANON_KEY contém uma service_role key. ' +
      'Essa chave ignora RLS e nunca pode ir para o browser.',
  )
}

export const appEnv = {
  supabaseUrl,
  supabaseAnonKey,

  /** Slug registrado em `portal.applications`. Vai no `?appId=` do login. */
  appId: 'supply',

  /** Bridge sempre same-origin (`/auth/*` e `/api/session` proxiados). */
  bridgeBaseUrl: '',

  authMode,
  devPassword: authMode === 'local' ? (devPassword ?? null) : null,

  isDev: import.meta.env.DEV,
} as const
